<template>
    <div>
        <div v-if="dayLogs" class="products-list" >
            <div class="content-top row">
                <div class="col-24 d-flex justify-content-between align-items-center">
                    <div class="content-top__title-box">
                        <h1 class="content-top__heading">Aktywność użytkownika {{dayLogs[0].wp_username}} z dnia {{dayLogs[0].created_day}}</h1>
                    </div>
                </div>
            </div>
            <div  class="content">

                <table  class="items-table">

                    <thead class="items-table__thead">
                        <h3>Dane odwiedzin</h3>
                        <tr class="items-table__tr">

                            <th class="items-table__th">
                                Strona
                            </th>

                            <th class="items-table__th">
                                Liczba odwiedzin podstrony
                            </th>

                            <th class="items-table__th">
                                Całkowita Liczba odwiedzin podstrony
                            </th>

                        </tr>

                    </thead>
                    <tbody class="items-table__tbody">
                        <template v-for="(logsArr, route) in routesData">
                            <tr class="items-table__tr" v-bind:key="route">

                                <td class="items-table__td">
                                    {{route}} 
                                </td>
                                
                                <td class="items-table__td">
                                    <div class="form-box__mobile-element">Liczba odwiedzin podstrony</div>
                                    {{logsArr.length}}
                                </td>

                                <td class="items-table__td">
                                    {{logsArr[0].route_total_occurance}}
                                </td>

                            </tr>
                        </template>

                    </tbody>
                </table>

            </div>

        </div><!-- // Products -->
        <div v-else class="content">
            Wróć do wyboru użytkownika ProMarmite
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';


    export default {
        props: [
            'dayLogs'
        ],
        data() {
            return {
                routesData: {}
            }
        },
        async mounted() {
            this.routesData = _.groupBy(this.dayLogs, 'wp_route');
        },
        
    }
</script>